import { EngineDataPoint } from "./engine-data";
import { Vehicle } from "./vehicle";

export class AnalyzedImageData {
  public vehicle?: Vehicle;
  public vehicleName?: string;
  public manufacturer?: string;
  public vehicleId?: number;
  public performancePoints?: number;
  public maxPower?: number;
  public maxTorque?: number;
  public weight?: number;
  public weightDistributionPercent?: number;
  public lowSpeed?: number;
  public highSpeed?: number;
  public rotationalG1?: number;
  public rotationalG2?: number;
  public rotationalG3?: number;
  public frontTires?: number;
  public rearTires?: number;
  public bodyHeightFront?: number;
  public bodyHeightRear?: number;
  public downforceFront?: number; 
  public downforceRear?: number;
  public minRPM?: number;
  public maxRPM?: number;
  public finalGearRatio: number;
  public wheelSize: number;
  public engineData?: EngineDataPoint[];
}
